// Same check duplicated across ~15 components in this codebase (Settings.vue, Pages.vue,
// Bots.vue, postCreator/mixins/main.js, ...) to hide a feature that ships to prod but isn't
// ready for real clients yet (see Settings.vue's own isProd(), used for the API Keys/MCP tab).
// Centralized here instead of copy-pasted again, so flipping it later is a one-line change.
export function isProd() {
  return process.env.VUE_APP_API_HOST === 'https://api.saas.mashup-web.com'
}

// Double authentification des users : sandbox uniquement tant qu'elle n'est pas validée.
// Pour l'ouvrir en prod : renvoyer `true` ici et passer user_security.enabled à true dans la config prod de l'engine.
export function mfaFeatureEnabled() {
  return !isProd()
}
